var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWheelchair(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:6px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M141.42,45.91A13.47,13.47,0,1,1,126.3,34,13.66,13.66,0,0,1,141.42,45.91ZM111.64,102.1l14.87-24.94-21.6-14.24L76,56.92,50.42,78.81A7.91,7.91,0,0,0,47,86.43a7.78,7.78,0,0,0,8.67,6.81,7.65,7.65,0,0,0,4.87-2.71l17.87-16L95.49,78.7,84.73,95.3m48.67,41.59,7.54-2.73,17.77,32.69h0a8,8,0,0,0,1.55,1.81,7.71,7.71,0,0,0,10.95-.8,7.9,7.9,0,0,0,0-10.15l-24.76-44.4-18.2,6.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M133,142.26c0,25.51-20.46,46.18-45.71,46.18s-45.7-20.67-45.7-46.18S62,96.08,87.24,96.08,133,116.75,133,142.26"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 87.24,
    cy: 142.26,
    rx: 45.7,
    ry: 46.18
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWheelchair);
export default __webpack_public_path__ + "static/media/WHEELCHAIR.116f5acf1f12ee59490c47d151a244f3.svg";
export { ForwardRef as ReactComponent };